// Study Group details data - separated to avoid babel plugin issues
export const studyGroupDetails = {
  1: {
    summary: 'Join our Web Application Penetration Testing study group to deepen your understanding of OWASP vulnerabilities, exploitation techniques, and secure coding practices. Through collaborative learning with peers and mentor guidance, you will master the tools and methodologies used by professional penetration testers.',
    topics: [
      'OWASP Top 10 Vulnerabilities',
      'SQL Injection & Authentication Attacks',
      'Cross-Site Scripting (XSS)',
      'Session Management Attacks',
      'API Security Testing',
      'Burp Suite Advanced Features'
    ],
    suitableFor: [
      'Security engineers improving web app testing skills',
      'Penetration testers wanting to specialize in web apps',
      'Developers learning secure coding practices',
      'Career changers focusing on web security'
    ],
    benefits: [
      'Peer learning from experienced members',
      'Hands-on practice with real applications',
      'Mentor feedback on lab work',
      'Networking with other security professionals',
      'Exclusive study group resources'
    ],
    curriculum: [
      'Weeks 1-2: Web Fundamentals & Reconnaissance',
      'Weeks 3-4: Injection & Authentication Attacks',
      'Weeks 5-6: Session & Data Security',
      'Weeks 7-8: API Testing & Capstone Project'
    ],
  },
};
